import { useCallback, useEffect, useRef } from "react";
import { getConversationsByShareId } from "../../api/index";
import { DbtDocsState, setConversations, setConversationsLoadingState } from "../DbtDocsReducer";
import { DbtDocsShareDetails, LoadingState } from "../types";
import { ConversationGroup } from "./context/types";
import {
  useDbtDocsCollaborationDispatch,
  useDbtDocsCollaborationSelector,
} from "../DbtDocsCollaborationProvider";

const PollingInterval = 10;
const useConversations = () => {
  const timer = useRef<NodeJS.Timeout | undefined>();
  const shareId = useDbtDocsCollaborationSelector(
    state => state.shareId
  ) as DbtDocsState["shareId"];
  const loadingState = useDbtDocsCollaborationSelector(
    state => state.conversationsLoadingState
  ) as LoadingState;
  const dispatch = useDbtDocsCollaborationDispatch();
  const conversations = useDbtDocsCollaborationSelector(state =>
    Object.keys(state.conversations || {})
  ) as ConversationGroup["conversation_group_id"][];

  const fetchConversations = useCallback(
    (shareId: DbtDocsShareDetails["share_id"]) => {
      clearTimeout(timer.current);
      getConversationsByShareId(shareId)
        .then(data => {
          console.log("useConversations", data);
          dispatch(setConversations(data?.dbt_docs_share_conversations));
          timer.current = setTimeout(() => {
            fetchConversations(shareId);
          }, PollingInterval * 1000);
        })
        .catch(err => console.error("error while fetching conversations list", err))
        .finally(() => {
          dispatch(setConversationsLoadingState(LoadingState.INITIALIZED));
        });
    },
    [dispatch]
  );

  useEffect(() => {
    if (loadingState !== LoadingState.UNINITIALIZED || !shareId) {
      return;
    }
    dispatch(setConversationsLoadingState(LoadingState.LOADING));
    fetchConversations(shareId);
  }, [dispatch, loadingState, conversations, shareId, fetchConversations]);

  return { isLoading: loadingState === LoadingState.LOADING };
};

export default useConversations;
